"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserSubscriptionCancelPreviewErrorResponseSchema = exports.UserSubscriptionCancelPreviewResponseSchema = exports.UserSubscriptionCancelPreviewParamsSchema = exports.UserSubscriptionCancelReasonErrorResponseSchema = exports.UserSubscriptionCancelReasonResponseSchema = exports.UserSubscriptionCancelReasonBodySchema = exports.UserSubscriptionCancelReasonOptionsResponseSchema = exports.UserSubscriptionCancelReasonOptionSchema = exports.UserSubscriptionCancelReasonParamsSchema = exports.UserSubscriptionResponseSchema = exports.UserSubscriptionScheduledChangeSchema = exports.UserSubscriptionPauseScheduledChangeSchema = exports.UserSubscriptionPlanChangeScheduledChangeSchema = exports.UserSubscriptionUsageSchema = exports.UserSubscriptionCurrentMonthUsageSchema = exports.UserSubscriptionMonthUsageSchema = exports.UserSubscriptionMonthEventSchema = exports.UserSubscriptionMonthAdjustmentSchema = exports.UserSubscriptionPlanChangeMonthAdjustmentSchema = exports.UserSubscriptionRenewalPaymentPendingMonthAdjustmentSchema = exports.UserSubscriptionPendingPaymentMonthAdjustmentSchema = exports.UserSubscriptionPauseMonthAdjustmentSchema = exports.UserSubscriptionSubscriptionDetailsSchema = exports.UserSubscriptionPaymentSchema = exports.UserSubscriptionServiceSchema = exports.UserSubscriptionTherapistSchema = exports.UserSubscriptionChangeScheduledResponseSchema = exports.UserSubscriptionPriceSchema = exports.UserSubscriptionPauseErrorResponseSchema = exports.UserSubscriptionPauseConflictingEventSchema = exports.UserSubscriptionPauseResponseSchema = exports.UserSubscriptionPauseParamsSchema = exports.UserSubscriptionCreateResponseSchema = exports.UserSubscriptionCreateBodySchema = exports.UserSubscriptionChangeErrorResponseSchema = exports.UserSubscriptionChangeResponseSchema = exports.UserSubscriptionChangeBodySchema = exports.UserSubscriptionChangeQuerySchema = exports.UserSubscriptionDetailGetParamsSchema = exports.UserSubscriptionDetailSchema = exports.UserSubscriptionActivePauseSchema = void 0;
const zod_1 = require("zod");
const common_1 = require("../../../common");
const SUBSCRIPTION_1 = require("../../../../enums/SUBSCRIPTION");
exports.UserSubscriptionActivePauseSchema = zod_1.z
    .object({
    id: common_1.NumericIdSchema,
    periodFrom: common_1.DateTimeStringSchema,
    periodTo: common_1.DateTimeStringSchema,
    pausedAt: common_1.DateTimeStringSchema,
    nextChargeDate: common_1.DateTimeStringSchema,
})
    .openapi('UserSubscriptionActivePause');
exports.UserSubscriptionDetailSchema = zod_1.z
    .object({
    id: common_1.NumericIdSchema,
    appUserId: common_1.NumericIdSchema,
    subscriptionId: common_1.NumericIdSchema,
    therapistId: common_1.NumericIdSchema,
    serviceId: common_1.NumericIdSchema,
    initPrice: common_1.PriceStringSchema,
    currency: zod_1.z.string(),
    status: zod_1.z.nativeEnum(SUBSCRIPTION_1.USER_SUBSCRIPTION_STATUS),
    createdAt: common_1.DateTimeStringSchema,
    actionRequiredUrl: common_1.UrlSchema.nullable(),
    previousUserSubscriptionId: common_1.NumericIdSchema.nullable(),
    previousUserSubscriptionCarryOver: zod_1.z.number().int().nullable(),
    activePause: exports.UserSubscriptionActivePauseSchema.nullable(),
})
    .openapi('UserSubscriptionDetail');
exports.UserSubscriptionDetailGetParamsSchema = zod_1.z.object({
    userSubscriptionId: zod_1.z.string().regex(/^\d+$/, 'Must be a numeric string').transform(Number),
});
exports.UserSubscriptionChangeQuerySchema = zod_1.z.object({
    userSubscriptionId: common_1.CoercedNumericIdSchema,
    subscriptionId: common_1.CoercedNumericIdSchema,
});
exports.UserSubscriptionChangeBodySchema = zod_1.z.object({
    method: zod_1.z.string().optional(), // This is PaymentMethodsReturningIntent, but we do not want to be strict here
    // opt-in AID-267 flow: schedule the change for next month with no new payment and carried-over
    // sessions, instead of the legacy cancel-and-pay-again flow. Only takes effect with the Stripe
    // gateway (PAYMENT_GATEWAY_SUBSCRIPTION=stripe) - absent/false is always legacy.
    seamless: zod_1.z.boolean().optional().default(false),
});
// the Stripe-gateway response (production); the legacy Comgate gateway returns a different,
// undocumented shape that is not worth modelling before AID-267 replaces the flow
exports.UserSubscriptionChangeResponseSchema = zod_1.z
    .object({
    redirect: zod_1.z.string().nullable(),
    clientSecret: zod_1.z.string().nullable(),
    newUserSubscriptionId: common_1.NumericIdSchema,
    changedSubscriptionId: common_1.NumericIdSchema,
})
    .openapi('UserSubscriptionChangeResponse');
exports.UserSubscriptionChangeErrorResponseSchema = zod_1.z
    .object({
    type: zod_1.z.nativeEnum(SUBSCRIPTION_1.SUBSCRIPTION_CHANGE_ERROR),
})
    .openapi('UserSubscriptionChangeErrorResponse');
exports.UserSubscriptionCreateBodySchema = zod_1.z
    .object({
    // coerced: the mobile clients have always been allowed to send these as numeric strings
    therapistId: common_1.CoercedNumericIdSchema,
    subscriptionId: common_1.CoercedNumericIdSchema,
    serviceId: common_1.CoercedNumericIdSchema,
    method: zod_1.z.string().optional(),
    startFromNextMonth: zod_1.z.boolean().optional().default(false),
})
    .openapi('UserSubscriptionCreateBody');
exports.UserSubscriptionCreateResponseSchema = zod_1.z
    .object({
    redirect: common_1.UrlSchema,
    clientSecret: zod_1.z.string().nullable(),
    newUserSubscriptionId: common_1.NumericIdSchema,
})
    .openapi('UserSubscriptionCreateResponse');
exports.UserSubscriptionPauseParamsSchema = zod_1.z.object({
    userSubscriptionId: common_1.CoercedNumericIdSchema,
});
exports.UserSubscriptionPauseResponseSchema = exports.UserSubscriptionActivePauseSchema.openapi('UserSubscriptionPauseResponse');
exports.UserSubscriptionPauseConflictingEventSchema = zod_1.z
    .object({
    id: common_1.NumericIdSchema,
    startDate: common_1.DateTimeStringSchema,
    endDate: common_1.DateTimeStringSchema,
})
    .openapi('UserSubscriptionPauseConflictingEvent');
exports.UserSubscriptionPauseErrorResponseSchema = zod_1.z
    .object({
    type: zod_1.z.nativeEnum(SUBSCRIPTION_1.SUBSCRIPTION_PAUSE_ERROR),
    // present only when type is EVENT_ALREADY_BOOKED_FOR_PERIOD - the booked sessions that need
    // to be rescheduled or cancelled before the target month can be paused
    events: zod_1.z.array(exports.UserSubscriptionPauseConflictingEventSchema).optional(),
})
    .openapi('UserSubscriptionPauseErrorResponse');
const YearMonthStringSchema = zod_1.z.string().regex(/^\d{4}-\d{2}$/, 'Must be a YYYY-MM string');
const DateOnlyStringSchema = zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be a YYYY-MM-DD string');
exports.UserSubscriptionPriceSchema = zod_1.z
    .object({
    amount: zod_1.z.number().nonnegative(),
    currency: zod_1.z.string(),
})
    .openapi('UserSubscriptionPrice');
// response for POST /userSubscription/change with seamless:true (AID-267) - the successor row
// created for next month, no payment/redirect involved
exports.UserSubscriptionChangeScheduledResponseSchema = zod_1.z
    .object({
    userSubscriptionId: common_1.NumericIdSchema,
    previousUserSubscriptionId: common_1.NumericIdSchema,
    effectiveFrom: YearMonthStringSchema,
    noOfSessionsIncluded: zod_1.z.number().int().nonnegative(),
    price: exports.UserSubscriptionPriceSchema,
})
    .openapi('UserSubscriptionChangeScheduledResponse');
exports.UserSubscriptionTherapistSchema = zod_1.z
    .object({
    id: common_1.NumericIdSchema,
    name: zod_1.z.string(),
    image: zod_1.z.string().nullable(),
})
    .openapi('UserSubscriptionTherapist');
exports.UserSubscriptionServiceSchema = zod_1.z
    .object({
    id: common_1.NumericIdSchema,
    name: zod_1.z.string(),
})
    .openapi('UserSubscriptionService');
exports.UserSubscriptionPaymentSchema = zod_1.z
    .object({
    // 3D-secure confirmation redirect URL, null when no confirmation is needed
    actionRequiredUrl: common_1.UrlSchema.nullable(),
    // null when there is no paid period yet to derive the next charge from (e.g. a brand new,
    // not-yet-paid subscription)
    nextBillingDate: DateOnlyStringSchema.nullable(),
})
    .openapi('UserSubscriptionPayment');
exports.UserSubscriptionSubscriptionDetailsSchema = zod_1.z
    .object({
    userSubscriptionId: common_1.NumericIdSchema,
    noOfSessionsIncluded: zod_1.z.number().int().nonnegative(),
    price: exports.UserSubscriptionPriceSchema,
    initPrice: common_1.PriceStringSchema,
    therapist: exports.UserSubscriptionTherapistSchema,
    service: exports.UserSubscriptionServiceSchema,
    validFromMonth: YearMonthStringSchema,
    startsNextMonth: zod_1.z.boolean(),
    // set only when status is ENDING - the last day the subscription is still usable
    endsOn: DateOnlyStringSchema.nullable(),
})
    .openapi('UserSubscriptionSubscriptionDetails');
exports.UserSubscriptionPauseMonthAdjustmentSchema = zod_1.z
    .object({
    type: zod_1.z.literal(SUBSCRIPTION_1.USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE.PAUSE),
    pauseId: common_1.NumericIdSchema,
})
    .openapi('UserSubscriptionPauseMonthAdjustment');
exports.UserSubscriptionPendingPaymentMonthAdjustmentSchema = zod_1.z
    .object({
    type: zod_1.z.literal(SUBSCRIPTION_1.USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE.PENDING_PAYMENT),
})
    .openapi('UserSubscriptionPendingPaymentMonthAdjustment');
exports.UserSubscriptionRenewalPaymentPendingMonthAdjustmentSchema = zod_1.z
    .object({
    type: zod_1.z.literal(SUBSCRIPTION_1.USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE.RENEWAL_PAYMENT_PENDING),
})
    .openapi('UserSubscriptionRenewalPaymentPendingMonthAdjustment');
exports.UserSubscriptionPlanChangeMonthAdjustmentSchema = zod_1.z
    .object({
    type: zod_1.z.literal(SUBSCRIPTION_1.USER_SUBSCRIPTION_MONTH_ADJUSTMENT_TYPE.PLAN_CHANGE),
    // the successor row (AID-267 seamless change) this month belongs to
    userSubscriptionId: common_1.NumericIdSchema,
})
    .openapi('UserSubscriptionPlanChangeMonthAdjustment');
exports.UserSubscriptionMonthAdjustmentSchema = zod_1.z
    .discriminatedUnion('type', [
    exports.UserSubscriptionPauseMonthAdjustmentSchema,
    exports.UserSubscriptionPendingPaymentMonthAdjustmentSchema,
    exports.UserSubscriptionRenewalPaymentPendingMonthAdjustmentSchema,
    exports.UserSubscriptionPlanChangeMonthAdjustmentSchema,
])
    .openapi('UserSubscriptionMonthAdjustment');
exports.UserSubscriptionMonthEventSchema = zod_1.z
    .object({
    id: common_1.NumericIdSchema,
    startDate: common_1.DateTimeStringSchema,
    endDate: common_1.DateTimeStringSchema,
})
    .openapi('UserSubscriptionMonthEvent');
exports.UserSubscriptionMonthUsageSchema = zod_1.z
    .object({
    month: YearMonthStringSchema,
    used: zod_1.z.number().int().nonnegative(),
    total: zod_1.z.number().int().nonnegative(),
    // null when the month's grant is the plan default; otherwise what changed it (only PAUSE
    // exists today)
    adjustment: exports.UserSubscriptionMonthAdjustmentSchema.nullable(),
    // the events counted in `used` - id/startDate/endDate only; fetch the rest from GET /event if needed
    events: zod_1.z.array(exports.UserSubscriptionMonthEventSchema),
})
    .openapi('UserSubscriptionMonthUsage');
exports.UserSubscriptionCurrentMonthUsageSchema = exports.UserSubscriptionMonthUsageSchema.extend({
    carryOver: zod_1.z.number().int(),
}).openapi('UserSubscriptionCurrentMonthUsage');
exports.UserSubscriptionUsageSchema = zod_1.z
    .object({
    // null when the subscription starts in a future month (no usage for the current month yet)
    currentMonth: exports.UserSubscriptionCurrentMonthUsageSchema.nullable(),
    pastMonths: zod_1.z.array(exports.UserSubscriptionMonthUsageSchema),
    upcomingMonths: zod_1.z.array(exports.UserSubscriptionMonthUsageSchema),
})
    .openapi('UserSubscriptionUsage');
// `status`/`subscription`/`usage` describe this calendar month only. When something is
// scheduled to take effect starting next month (a plan change already paid/pending, or a pause
// that hasn't started yet), it shows up here instead of leaking into the "current" fields.
exports.UserSubscriptionPlanChangeScheduledChangeSchema = zod_1.z
    .object({
    type: zod_1.z.literal(SUBSCRIPTION_1.USER_SUBSCRIPTION_SCHEDULED_CHANGE_TYPE.PLAN_CHANGE),
    effectiveFrom: YearMonthStringSchema,
    noOfSessionsIncluded: zod_1.z.number().int().nonnegative(),
    price: exports.UserSubscriptionPriceSchema,
})
    .openapi('UserSubscriptionPlanChangeScheduledChange');
exports.UserSubscriptionPauseScheduledChangeSchema = zod_1.z
    .object({
    type: zod_1.z.literal(SUBSCRIPTION_1.USER_SUBSCRIPTION_SCHEDULED_CHANGE_TYPE.PAUSE),
    effectiveFrom: YearMonthStringSchema,
    pauseId: common_1.NumericIdSchema,
})
    .openapi('UserSubscriptionPauseScheduledChange');
exports.UserSubscriptionScheduledChangeSchema = zod_1.z
    .discriminatedUnion('type', [
    exports.UserSubscriptionPlanChangeScheduledChangeSchema,
    exports.UserSubscriptionPauseScheduledChangeSchema,
])
    .openapi('UserSubscriptionScheduledChange');
exports.UserSubscriptionResponseSchema = zod_1.z
    .object({
    status: zod_1.z.nativeEnum(SUBSCRIPTION_1.USER_SUBSCRIPTION_STATE),
    // null when status is NONE
    payment: exports.UserSubscriptionPaymentSchema.nullable(),
    subscription: exports.UserSubscriptionSubscriptionDetailsSchema.nullable(),
    usage: exports.UserSubscriptionUsageSchema.nullable(),
    // null when nothing is scheduled to change starting next month
    scheduledChange: exports.UserSubscriptionScheduledChangeSchema.nullable(),
})
    .openapi('UserSubscriptionResponse');
exports.UserSubscriptionCancelReasonParamsSchema = zod_1.z.object({
    userSubscriptionId: common_1.CoercedNumericIdSchema,
});
const CancelReasonTagSchema = zod_1.z.string().min(1);
exports.UserSubscriptionCancelReasonOptionSchema = zod_1.z
    .object({
    id: common_1.NumericIdSchema,
    tag: CancelReasonTagSchema,
})
    .openapi('UserSubscriptionCancelReasonOption');
exports.UserSubscriptionCancelReasonOptionsResponseSchema = zod_1.z
    .array(exports.UserSubscriptionCancelReasonOptionSchema)
    .openapi('UserSubscriptionCancelReasonOptionsResponse');
exports.UserSubscriptionCancelReasonBodySchema = zod_1.z
    .object({
    cancelReasonOptionId: common_1.NumericIdSchema,
})
    .openapi('UserSubscriptionCancelReasonBody');
exports.UserSubscriptionCancelReasonResponseSchema = zod_1.z
    .object({
    id: common_1.NumericIdSchema,
    userSubscriptionId: common_1.NumericIdSchema,
    cancelReasonOptionId: common_1.NumericIdSchema,
    tag: CancelReasonTagSchema,
})
    .openapi('UserSubscriptionCancelReasonResponse');
exports.UserSubscriptionCancelReasonErrorResponseSchema = zod_1.z
    .object({
    type: zod_1.z.nativeEnum(SUBSCRIPTION_1.SUBSCRIPTION_CANCEL_REASON_ERROR),
})
    .openapi('UserSubscriptionCancelReasonErrorResponse');
exports.UserSubscriptionCancelPreviewParamsSchema = zod_1.z.object({
    userSubscriptionId: common_1.CoercedNumericIdSchema,
});
exports.UserSubscriptionCancelPreviewResponseSchema = zod_1.z
    .object({
    unusedSessionsCount: zod_1.z.number().int().nonnegative(),
    eventsToKeep: zod_1.z.array(exports.UserSubscriptionMonthEventSchema),
    eventsToCancel: zod_1.z.array(exports.UserSubscriptionMonthEventSchema),
})
    .openapi('UserSubscriptionCancelPreviewResponse');
exports.UserSubscriptionCancelPreviewErrorResponseSchema = zod_1.z
    .object({
    type: zod_1.z.nativeEnum(SUBSCRIPTION_1.SUBSCRIPTION_CANCEL_PREVIEW_ERROR),
    message: zod_1.z.string(),
})
    .openapi('UserSubscriptionCancelPreviewErrorResponse');
